<template>
    <div>
        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Background
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Colour
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-colour
                    class="reset"
                    placeholder="transparent"
                    :classes="{ input: { 'input--composer': true } }"
                    v-model="element.settings.design.background.color"
                />
            </div>
        </div>

        <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="flex items-center">
                <div class="w-2/5">
                    <label class="text-xs text-grey-darker" for="URL">
                    URL
                </label>
                </div>
                <div class="flex-grow w-3/5">
                    <app-field-text
                        class="reset"
                        :classes="{ input: { 'input--composer': true } }"
                        name="backgroundURL"
                        placeholder="https://domain.tld/image-path"
                        v-model="element.settings.design.background.url"
                    />
                </div>
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-full">
                <label class="text-xs text-grey-darker">
                    File
                </label>
                <app-field-file
                    class="reset mt-2"
                    v-model="element.settings.design.background.file"
                    :types="{images: true, files: false}"
                    :filetypes="['png']"
                />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Attachment
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.background.attachment.options" v-model="element.settings.design.background.attachment" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Position
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.background.position.options" v-model="element.settings.design.background.position" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Repeat
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.background.repeat.options" v-model="element.settings.design.background.repeat" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Size
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.background.size.options" v-model="element.settings.design.background.size" />
            </div>
        </div>

        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Text
        </div>
        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Colour
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-colour class="reset" :classes="{ input: { 'input--composer': true } }"  v-model="element.settings.design.text.color" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Family
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.text.family.options" v-model="element.settings.design.text.family" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Size
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.text.size.options" v-model="element.settings.design.text.size" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Weight
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.text.weight.options" v-model="element.settings.design.text.weight" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Style
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-fancy-option
                    class="reset"
                    :data="configs.fontStyle"
                    v-model="element.settings.design.text.style"
                />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Align
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-fancy-option
                    class="reset"
                    :data="configs.align"
                    v-model="element.settings.design.text.align"
                />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Capitalisation
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.text.capitalisation.options" v-model="element.settings.design.text.capitalisation" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Line Height
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.text.lineheight.options" v-model="element.settings.design.text.lineheight" />
            </div>
        </div>

        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Letter Spacing
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.text.spacing.options" v-model="element.settings.design.text.spacing" />
            </div>
        </div>

        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Style
        </div>
        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="w-1/2">
                <label class="text-xs text-grey-darker">
                    Shadow
                </label>
            </div>
            <div class="w-1/2 text-right">
                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.style.shadow.options" v-model="element.settings.design.shadow" />
            </div>
        </div>

        <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
            Attributes
        </div>

        <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="flex items-center">
                <div class="w-2/5">
                    <label class="text-xs text-grey-darker" for="Classes">
                    Classes
                </label>
                </div>
                <div class="flex-grow w-3/5">
                    <app-field-text
                        class="reset"
                        :classes="{ input: { 'input--composer': true } }"
                        name="attributesClasses"
                        placeholder="Seperated by spaces"
                        v-model="element.settings.attributes.classes"
                    />
                </div>
            </div>
        </div>

        <div class="px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
            <div class="flex items-center">
                <div class="w-2/5">
                    <label class="text-xs text-grey-darker" for="URL">
                    URL
                </label>
                </div>
                <div class="flex-grow w-3/5">
                    <app-field-text
                        class="reset"
                        :classes="{ input: { 'input--composer': true } }"
                        name="attributesID"
                        placeholder="Only one ID allowed"
                        v-model="element.settings.attributes.id"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import FieldSelect from '@/components/fields/inputs/Select';
    import FieldColour from '@/components/fields/inputs/Colour';
    import FieldFancyOption from '@/components/fields/inputs/FancyOption';
    import FieldText from '@/components/fields/inputs/Text';
    import FileField from '@/components/fields/inputs/File';

    export default {
        components: {
            'app-field-select': FieldSelect,
            'app-field-colour': FieldColour,
            'app-field-fancy-option': FieldFancyOption,
            'app-field-text': FieldText,
            'app-field-file': FileField,
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            data:  [
                0, 1, 2, 4, 8
            ],
            fields: {
                background: {
                    colour: {
                        name: 'Colour',
                        attribute: 'backgroundColour',
                        placeholder: 'transparent'
                    },
                    url: {
                        name: 'URL',
                        attribute: 'backgroundURL',
                        placeholder: 'https://domain.tld/image-path'
                    },
                    file: {
                        name: 'File',
                        attribute: 'backgroundFile'
                    },
                    attachment: {
                        name: 'Attachment',
                        attribute: 'attachment',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'bg-fixed',
                                label: 'Fixed'
                            },
                            {
                                value: 'bg-local',
                                label: 'Local'
                            },
                            {
                                value: 'bg-scroll',
                                label: 'Scroll'
                            }
                        ]
                    },
                    position: {
                        name: 'Position',
                        attribute: 'position',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'bg-bottom',
                                label: 'Bottom'
                            },
                            {
                                value: 'bg-center',
                                label: 'Center'
                            },
                            {
                                value: 'bg-left',
                                label: 'Left'
                            },
                            {
                                value: 'bg-left-bottom',
                                label: 'Left Bottom'
                            },
                            {
                                value: 'bg-left-top',
                                label: 'Left Top'
                            },
                            {
                                value: 'bg-right',
                                label: 'Right'
                            },
                            {
                                value: 'bg-right',
                                label: 'Right Bottom'
                            },
                            {
                                value: 'bg-right-top',
                                label: 'Right Top'
                            },
                            {
                                value: 'bg-top',
                                label: 'Top'
                            }
                        ]
                    },
                    repeat: {
                        name: 'Repeat',
                        attribute: 'repeat',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'bg-repeat',
                                label: 'Repeat'
                            },
                            {
                                value: 'bg-no-repeat',
                                label: 'No repeat'
                            },
                            {
                                value: 'bg-repeat-x',
                                label: 'Repeat X'
                            },
                            {
                                value: 'bg-repeat-y',
                                label: 'Repeat Y'
                            }
                        ]
                    },
                    size: {
                        name: 'Size',
                        attribute: 'size',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'bg-auto',
                                label: 'Auto'
                            },
                            {
                                value: 'bg-cover',
                                label: 'Cover'
                            },
                            {
                                value: 'bg-contain',
                                label: 'Contain'
                            }
                        ]
                    }
                },
                text: {
                    color: {
                        name: 'Colour',
                        attribute: 'textColour',
                        placeholder: 'transparent'
                    },
                    style: {
                        name: 'Style',
                        attribute: 'style'
                    },
                    align: {
                        name: 'Align',
                        attribute: 'align'
                    },
                    capitalisation: {
                        name: 'Capitalisation',
                        attribute: 'capitalisation',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'uppercase',
                                label: 'Uppercase'
                            },
                            {
                                value: 'lowercase',
                                label: 'Lowercase'
                            }
                        ]
                    },
                    lineheight: {
                        name: 'Line Height',
                        attribute: 'lineheight',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'leading-none',
                                label: 'Compact'
                            },
                            {
                                value: 'leading-tight',
                                label: 'Tight'
                            },
                            {
                                value: 'leading-normal',
                                label: 'Normal'
                            },
                            {
                                value: 'leading-loose',
                                label: 'Loose'
                            }
                        ]
                    },
                    spacing: {
                        name: 'Spacing',
                        attribute: 'spacing',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'tracking-tight',
                                label: 'Tight'
                            },
                            {
                                value: 'tracking-normal',
                                label: 'Normal'
                            },
                            {
                                value: 'tracking-wide',
                                label: 'Wide'
                            }
                        ]
                    },
                    weight: {
                        name: 'Weight',
                        attribute: 'weight',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'font-hairline',
                                label: 'Hairline'
                            },
                            {
                                value: 'font-thin',
                                label: 'Thin'
                            },
                            {
                                value: 'font-light',
                                label: 'Light'
                            },
                            {
                                value: 'font-normal',
                                label: 'Normal'
                            },
                            {
                                value: 'font-medium',
                                label: 'Medium'
                            },
                            {
                                value: 'font-semibold',
                                label: 'Semi Bold'
                            },
                            {
                                value: 'font-bold',
                                label: 'Bold'
                            },
                            {
                                value: 'font-extrabold',
                                label: 'Extra Bold'
                            },
                            {
                                value: 'font-black',
                                label: 'Black'
                            }
                        ]
                    },
                    size: {
                        name: 'Size',
                        attribute: 'size',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'text-xs',
                                label: 'Extra Small'
                            },
                            {
                                value: 'text-sm',
                                label: 'Small'
                            },
                            {
                                value: 'text-base',
                                label: 'Normal'
                            },
                            {
                                value: 'text-lg',
                                label: 'Large'
                            },
                            {
                                value: 'text-xl',
                                label: 'Extra Large'
                            },
                            {
                                value: 'text-2xl',
                                label: 'Extra Large 2'
                            },
                            {
                                value: 'text-3xl',
                                label: 'Extra Large 3'
                            },
                            {
                                value: 'text-4xl',
                                label: 'Extra Large 4'
                            },
                            {
                                value: 'text-5xl',
                                label: 'Extra Large 5'
                            }
                        ]
                    },
                    family: {
                        name: 'Family',
                        attribute: 'family',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'font-sans',
                                label: 'Sans'
                            },
                            {
                                value: 'font-serif',
                                label: 'Serif'
                            },
                            {
                                value: 'font-mono',
                                label: 'Mono'
                            }
                        ]
                    }
                },
                style: {
                    shadow: {
                        name: 'Shadow',
                        attribute: 'shadow',
                        options: [
                            {
                                value: '',
                                label: 'None'
                            },
                            {
                                value: 'small',
                                label: 'Small'
                            },
                            {
                                value: 'md',
                                label: 'Medium'
                            },
                            {
                                value: 'lg',
                                label: 'Large'
                            }
                        ]
                    },
                },
                attributes: {
                    classes: {
                        name: 'Classes',
                        attribute: 'attributesClasses',
                        placeholder: 'Seperated by spaces'
                    },
                    id: {
                        name: 'ID',
                        attribute: 'attributesID',
                        placeholder: 'Only one ID allowed'
                    }
                }
            },
            configs: {
                fontStyle: [
                    {
                        value: 'italic',
                        icon: 'italic'
                    },
                    {
                        value: 'roman',
                        icon: 'font'
                    },
                    {
                        value: 'underline',
                        icon: 'underline'
                    },
                    {
                        value: 'line-through',
                        icon: 'strikethrough'
                    }
                ],
                align: [
                    {
                        value: 'left',
                        icon: 'align-left'
                    },
                    {
                        value: 'center',
                        icon: 'align-center'
                    },
                    {
                        value: 'right',
                        icon: 'align-right'
                    },
                    {
                        value: 'justify',
                        icon: 'align-justify'
                    }
                ],
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Forms/Partials/Design.vue